import React, { useImperativeHandle, useState, useRef } from 'react'
import styles from './index.scss'
import classnames from 'classnames'
import { RightOutline } from 'antd-mobile-icons'
import { IDpPickerProps } from './utils'
import PickerView from './view'
// 只考虑单日期，单时间，或者单日期+时间
const DpDatePicker: React.FC<IDpPickerProps> = (props) => {
  const [visible, updateVisible] = useState(false)
  const useRefPicker: any = useRef()

  // //用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      setUpdateVisible: useRefPicker?.current?.setUpdateVisible,
    }
  })
  return (
    <div style={props?.style} className={classnames([styles['dp-picker'], { [styles['dp-picker--disabled']]: props?.disabled}])}>
      <div
        onClick={() => {
          useRefPicker?.current?.setUpdateVisible?.()
          updateVisible(!visible)
        }}
        className={styles['dp-picker-desc']}
      >
        <div className={styles['dp-picker-desc-body']} style={props?.bodyStyle}>
          {props?.value || (
            <span className={styles['dp-picker-placeholder']}>
              {props?.placeholder || '请选择时间'}
            </span>
          )}
        </div>
        {!props?.disabled && <RightOutline  className={styles['dp-picker-arrows']} />}
      </div>
      <PickerView onRef={(e: any) => useRefPicker.current = e} {...props} visible={visible} onCancel={(v) => updateVisible(v)} />
    </div>
  )
}

export default DpDatePicker
